import { LoadingButton } from '@mui/lab';
import { Tooltip } from '@mui/material';
import type { KeyboardEventHandler, MouseEventHandler } from 'react';
import IcomxCommunicationIcon, {
  ICOMX_DISABLED_COMMUNICATIONS_LABEL,
  ICOMX_OPEN_COMMUNICATIONS_LABEL,
} from './IcomxCommunicationIcon';

interface IcomxLauncherButtonProps {
  disabled: boolean;
  loading: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
  disabledReason?: string;
  tooltip?: string;
  appearance?: 'contained' | 'inline';
}

export default function IcomxLauncherButton({
  disabled,
  loading,
  onClick,
  disabledReason = ICOMX_DISABLED_COMMUNICATIONS_LABEL,
  tooltip = ICOMX_OPEN_COMMUNICATIONS_LABEL,
  appearance = 'contained',
}: IcomxLauncherButtonProps) {
  const isInline = appearance === 'inline';
  const buttonSize = isInline ? 28 : 34;
  const handleClick: MouseEventHandler<HTMLButtonElement> = (event) => {
    event.stopPropagation();
    onClick(event);
  };
  const stopDoubleClickPropagation: MouseEventHandler<HTMLButtonElement> = (event) => {
    event.stopPropagation();
  };
  const stopKeyboardPropagation: KeyboardEventHandler<HTMLButtonElement> = (event) => {
    event.stopPropagation();
  };

  return (
    <Tooltip title={disabled ? disabledReason : tooltip}>
      <span
        onClick={(event) => event.stopPropagation()}
        onDoubleClick={(event) => event.stopPropagation()}
        onKeyDown={(event) => event.stopPropagation()}
      >
        <LoadingButton
          aria-label={tooltip}
          loading={loading}
          loadingPosition="center"
          variant="contained"
          color="primary"
          disabled={disabled}
          onClick={handleClick}
          onDoubleClick={stopDoubleClickPropagation}
          onKeyDown={stopKeyboardPropagation}
          sx={{
            minWidth: buttonSize,
            width: buttonSize,
            height: buttonSize,
            p: 0,
            borderRadius: 1.25,
            color: 'common.white',
            ml: isInline ? 0.25 : 0,
            boxShadow: 'none',
            minHeight: 'unset',
            '&.MuiButton-contained': {
              backgroundColor: 'primary.main',
            },
            '&.MuiButton-contained:hover': {
              backgroundColor: 'primary.dark',
              boxShadow: 'none',
            },
            '&.Mui-disabled': {
              color: 'common.white',
              backgroundColor: 'action.disabledBackground',
            },
            '& .MuiCircularProgress-root': {
              color: 'common.white',
            },
          }}
        >
          <IcomxCommunicationIcon fontSize="small" sx={{ color: 'inherit' }} />
        </LoadingButton>
      </span>
    </Tooltip>
  );
}
